import React, { useState, useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import LandingPage from './components/LandingPage';
import AuthPage from './components/AuthPage';
import App from './components/App';

function Spinner() {
  return (
    <div className="spinner-page">
      <div className="spinner-ring"></div>
    </div>
  );
}

export default function Root() {
  const { user, loading } = useAuth();
  const [showAuth, setShowAuth] = useState(false);

  // When user signs in, automatically close auth page
  useEffect(() => {
    if (user && showAuth) {
      setShowAuth(false);
      // Clean URL if needed
      if (window.location.pathname === '/login') {
        window.history.replaceState({}, '', '/');
      }
    }
  }, [user, showAuth]);

  // If URL is /login, show auth
  useEffect(() => {
    if (window.location.pathname === '/login') {
      setShowAuth(true);
    }
  }, []);

  if (loading) return <Spinner />;

  // User is signed in → always show app
  if (user) return <App />;

  // Not signed in but auth page requested
  if (showAuth) {
    return (
      <AuthPage onBack={() => {
        setShowAuth(false);
        window.history.replaceState({}, '', '/');
      }} />
    );
  }

  // Not signed in → landing
  return <LandingPage onSignIn={() => setShowAuth(true)} />;
}
